import React, { useState } from 'react';
import { Route, Routes, Link, useLocation } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';

import ChangePassword from './components/ChangePassword/ChangePassword';
import UserManagement from './components/UserManagement/UserManagement';
import CategoryManagement from './components/CategoryManagement/CategoryManagement';
import CategorySelector from './components/CategorySelector/CategorySelector.js'
import MaintenanceManagement from './components/MaintenanceManagement/MaintenanceManagement.js'
import StatisticsManagement from './components/StatisticsManagement/StatisticsManagement.js'
import ImageManagement from './components/ImageManagement/ImageManagement';
import Login from './components/Login';
import Notification from './components/Notification/Notification';
import { WebSocketProvider } from './components/WebsocketComponent/WebSocketProvider.js';
import DisplayWebSocketMessageComponent from './components/WebsocketComponent/DisplayWebSocketMessageComponent.js';
import UploadProgressBar from './components/WebsocketComponent/UploadProgressBar.js'; // Import the new component
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(true);
  const [user, setUser] = useState(null);
  const [notification, setNotification] = useState({ message: '', type: '' });


  const handleLogin = (userData) => {
    if (userData.firstLogin) {
      setIsFirstLogin(true);
    } else {
      setIsFirstLogin(false);
    }
    setIsLoggedIn(true);
    setUser(userData);
  };

  const handleLogout = (closeWebSocket) => {
    setIsLoggedIn(false);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('level');
    localStorage.removeItem('id');
    if (window.mySocket) {
      window.mySocket.close();
      window.mySocket = null;
    }

    setNotification({ message: 'Sikeres kijelentkezés!', type: 'success' });
  };

  return (

    <div className="App">
      {/* Header */}
      {!isLoggedIn && (
        <header style={{ padding: '1rem', textAlign: 'center', fontSize: '0.8rem', color: '#888', backgroundColor: '#f5f5f5' }}>

          <span>
            Az oldal kizárólag a működéshez szükséges technikai sütiket használ. Harmadik fél részére adatot nem továbbít.
          </span>
        </header>
      )}
      {isLoggedIn ? (
        isFirstLogin ? (
          <ChangePassword user={user} handleLogout={handleLogout} />
        ) : (
          <WebSocketProvider> {/* WebSocketProvider csak sikeres bejelentkezés után */}
            <AuthenticatedApp user={user} handleLogout={handleLogout} />
          </WebSocketProvider>
        )
      ) : (

        <Login onLogin={handleLogin} />

      )}
      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>

  );
}

function AuthenticatedApp({ user, handleLogout }) {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // State for sidebar visibility
  const [openMenu, setOpenMenu] = useState(null); // State to track which submenu is open


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  return (
    <>
      <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        {isSidebarOpen && (
          <>
            <h1>Welcome, {user?.fullname} </h1>
            <div className="sidebar-scroll">
              <nav>
                <ul>
                  <li>
                    <div className="menu-item" onClick={() => toggleMenu('users')}>
                      User Management
                    </div>
                    {openMenu === 'users' && (
                      <ul className="submenu">
                        <li><Link to="/users/list" className={location.pathname === '/users/list' ? 'active' : ''}>List Users</Link></li>
                        {user.level === 3 && <li><Link to="/users/create" className={location.pathname === '/users/create' ? 'active' : ''}>Create Users</Link></li>}
                      </ul>
                    )}
                  </li>
                  {user.level > 2 && (
                    <li>
                      <div className="menu-item" onClick={() => toggleMenu('categories')}>
                        Category Management
                      </div>
                      {openMenu === 'categories' && (
                        <ul className="submenu">
                          <li><Link to="/categories/list" className={location.pathname === '/categories/list' ? 'active' : ''}>List Categories</Link></li>
                          <li><Link to="/categories/create" className={location.pathname === '/categories/create' ? 'active' : ''}>Create Categories</Link></li>

                        </ul>
                      )}
                    </li>
                  )}
                  <li>
                    <div className="menu-item" onClick={() => toggleMenu('images')}>
                      Image Management
                    </div>
                    {openMenu === 'images' && (
                      <ul className="submenu">
                        <li><Link to="/images/list" className={location.pathname === '/images/list' ? 'active' : ''}>List Media</Link></li>
                        {user.level === 3 && (
                          <>
                            <li><Link to="/images/delete" className={location.pathname === '/images/delete' ? 'active' : ''}>Delete Media</Link></li>
                            <li><Link to="/images/assign" className={location.pathname === '/images/assign' ? 'active' : ''}>Assign Category</Link></li>
                            <li><Link to="/images/upload" className={location.pathname === '/images/upload' ? 'active' : ''}>Upload Media</Link></li>
                          </>
                        )}
                      </ul>
                    )}
                  </li>
                  <li>
                    <div className="menu-item" >
                      <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                        Kategóriák
                      </Link>
                    </div>
                  </li>
                  <li><button onClick={() => handleLogout(true)}>Logout</button></li>
                  {user.level > 2 && (
                    <li>
                      <div className="menu-item" onClick={() => toggleMenu('maintenance')}>
                        Karbantartás
                      </div>
                      {openMenu === 'maintenance' && (
                        <ul className="submenu">
                          <li><Link to="/maintenance/duplicate" className={location.pathname === '/maintenance/duplicate' ? 'active' : ''}>Duplicate Medias</Link></li>
                          <li><Link to="/maintenance/restore" className={location.pathname === '/maintenance/restore' ? 'active' : ''}>Restore Media</Link></li>
                        </ul>
                      )}
                    </li>
                  )}
                  {user.level > 2 && (
                    <li>
                      <div className="menu-item" onClick={() => toggleMenu('statistics')}>
                        Statisztikák
                      </div>
                      {openMenu === 'statistics' && (
                        <ul className="submenu">
                          <li><Link to="/statistics/top-media" className={location.pathname === '/statistics/top-media' ? 'active' : ''}>Top Media</Link></li>
                          <li><Link to="/statistics/user-activity" className={location.pathname === '/statistics/user-activity' ? 'active' : ''}>User Activity</Link></li>
                          <li><Link to="/statistics/daily-views" className={location.pathname === '/statistics/daily-views' ? 'active' : ''}>Daily Views</Link></li>
                          <li><Link to="/statistics/uploads" className={location.pathname === '/statistics/uploads' ? 'active' : ''}>Uploads</Link></li>
                          <li><Link to="/statistics/login-count" className={location.pathname === '/statistics/login-count' ? 'active' : ''}>Login Count</Link></li>
                          <li><Link to="/statistics/parent-categories" className={location.pathname === '/statistics/parent-categories' ? 'active' : ''}>Categories</Link></li>
                          <li><Link to="/statistics/storage" className={location.pathname === '/statistics/storage' ? 'active' : ''}>Storage</Link></li>
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              </nav>
              {user.level > 2 && <DisplayWebSocketMessageComponent />}
            </div>
            {user.level > 2 && <UploadProgressBar />} {/* Render the progress bar */}
          </>
        )}
      </div>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isSidebarOpen ? <i className="bi bi-x-lg"></i> : <i className="bi bi-list"></i>}
      </button>
      <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Routes>
          <Route path="/" element={<CategorySelector user={user} />} />  {/* 👈 új kezdőlap */}
          {/* <Route path="/" element={<Navigate to="/images/list" state={location.state} />} />*/}
          <Route path="/users/*" element={<UserManagement />} />
          <Route path="/categories/*" element={<CategoryManagement />} />
          <Route path="/images/*" element={<ImageManagement />} />
          <Route path="/maintenance/*" element={<MaintenanceManagement />} />
          <Route path="/statistics/*" element={<StatisticsManagement />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
